import {firebase} from '../../utilities'
import {auth} from '../../Auth'
import { Timestamp } from 'firebase/firestore'


export default function stampMetadata(form) {
  if (!form.created) form.created = Timestamp.now()
  form.updated = Timestamp.now()
  if (!form.createdBy) {
    const {id, name} = auth.sunkaizenUser
    form.createdBy = {id, name}
  }
  if (!form.organization) {
    form.organization = auth.sunkaizenUser.organization
  }
}
